import { useRef } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";

import useUiuxStore from "src/store/useUiuxStore";
import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_WMS1101_R01 } from "./Content_WMS1101_R01";
import { AgGridReact } from "ag-grid-react";
import { WMS1101_R01DetailDto, WMS1101_R01HeaderDto } from "./Dto_WMS1101_R01";
import SearchSection_WMS1101_R01 from "./SearchSection_WMS1101_R01";
import { Table_WMS1101_R01 } from "./Table_WMS1101_R01";
import { DetailTable_WMS1101_R01 } from "./DetailTable_WMS1101_R01";


export const Container_WMS1101_R01 = () => {

	const { tabList, setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'WMS1101_R01',
		type: 'width',
		storageKey: 'WMS1101_R01-split-width',
		min: 5,
		max: 80,
		default: 27
	} as const;

	const gridRef = useRef<AgGridReact<WMS1101_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<WMS1101_R01DetailDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	const {
		splitValue,
		handleMouseDown,
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const {
		handleExcelClick,
		fetchData,
		defaultWMS1101_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	} = Content_WMS1101_R01({
		gridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	});

	return <div className={`content-container`}>
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={() => {}}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={() => {}}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_WMS1101_R01 onEnterKeyDown={() => { fetchData(); }} />

		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_WMS1101_R01 gridRef={gridRef} handleCreateClick={handleCreateClick} />
			</div>
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				data-comment="리사이저"
			/>
			<div className="h-full" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				<DetailTable_WMS1101_R01
					detailGridRef={detailGridRef}
					defaultWMS1101_R01DetailRow={defaultWMS1101_R01DetailRow()}
				/>
			</div>
		</div>
		<Message />
	</div>
}
